import React, { useState } from 'react';
import './TutorialComponent.css'; // Optional CSS for styling

const TutorialComponent = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openTutorial = () => setIsOpen(true);
  const closeTutorial = () => setIsOpen(false);

  const handleOutsideClick = (e) => {
    if (e.target.className === 'tutorial-modal-overlay') {
      closeTutorial();
    }
  };

  return (
    <>
      {/* Tutorial Button */}
      <button className="tutorial-button" onClick={openTutorial}>
        Tutorial
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="tutorial-modal-overlay" onClick={handleOutsideClick}>
          <div className="tutorial-modal-content">
            <h1>Getting Started</h1>
            <ol>
              <li>Copy-and-paste or write your comedy material into the editor on the left using single-line spacing.</li>
              <li>Leave an empty line between each joke.</li>
              <li>Type three asteriskes *** at the beginning of a line to tell the app that you are starting a new bit.</li>
            </ol>

            <div className="tutorial-example-container">
              <p className="tutorial-title">Example</p>
              <span className="tutorial-text">
                  How does a penguin build it's house?<br/>
                  Igloos it together!<br/>
                  <br/>
                  Why did the scarecrow win an award?<br/>
                  He was outstanding in his field!<br/>
                  <br/>
                  ***<br/>
                  <br/>
                  Why don't skeletons fight each other?<br/>
                  They don't have the guts!<br/>
              </span>
            </div>
            This example material has 2 bits. Bit 1 has 2 jokes and bit 2 has 1 joke. 
            <br/><br/>
            
            <h1>Assigning Punchlines To Jokes</h1>
            Jokes in the text editor must be at least 2 lines long (setup and punchline) before assigning punchlines.
            <ul>

              <li>Click on the punchline of each joke within the preview window.</li>
              <li>The app will automatically structure your joke. Green = Setup. Red = Punchline. Blue = Tagline.</li>
              <li>The first line is reserved as a setup.</li>
              <li>You must have at least one punchline assigned before using performance metrics.</li>
            </ul>

            <br />
            <h1>Recording Audience Response</h1>
            Now lets add audience responses for each joke. You must have assigned at least one punchline to do this step. Scroll down to the bottom.
            <ol>
              <li>Click the “+” button on a joke.</li>
              <li>Click “Record”.</li>
              <li>Select "All" to record the entire joke, or click on the specific punchline or tagline you want to record for.</li>
              <li>Click “Start”.</li>
              <li>Drag the slider up and down to tell the app how the audience responded at that moment. Set the slider to 0 any time you’re inside a setup. Use 1 for a bombed joke and 10 for huge laugh.</li>
            </ol>

            <br />
            <h2>How to Get an Accurate Recording </h2>
            <ul>
                <li>Listen to a recording of your performance while recording.</li>
                <li>For the best accuracy, <b>hit "Start" the moment the previous joke's laugh go to zero.</b> (even if you're not speaking yet). The app considers the moment laughs stop to be the beginning of the next joke.</li>
            </ul>
            





            <br />
            <h1>Analytics</h1>
            <p><strong>Performance Analytics:</strong> Shows analytics for your entire performance.</p>
            <p><strong>Bit Analytics:</strong> Shows analytics for a group of jokes.</p>
            <p><strong>Joke Analytics:</strong> Shows analytics for a specific joke. Click the “+” button to view joke analytics.</p>

            <p><strong>Percentage Bar Above Graph:</strong> Displays the percentage of time the comedian spent inside a setup, punchline, and taglines as well as the percentage of audience laughter.</p>

            <p>If the speaking rate shows infinity, then you haven’t recorded an audience response for that joke yet.</p>



            
            <br />
            <h1>Save & Import Files</h1>

            <p><strong>Save Botton:</strong> Saves a JSON file to your computer that can be loaded into the app later. Beta v0.2 is not compatible with v0.1 JSON files.</p>

            <p><strong>Import Button:</strong> Only use if you have previously saved data from this app (must be v0.2.0).</p>

            <p><strong>Send Feedback Button:</strong> Links to Google Forms</p>

            <br/>
            <h1>Key Changes Between v0.1 and v0.2</h1>
            <ol>
              <li>The text editor is now the central tool for writing and editing material. When you save audience response data, the app automatically links that data to the joke's text. If you later modify the joke, the app will try to match the new version with the original text. If a match is found, the app will retain the original audience responses for the joke. This allows you to freely edit your jokes without losing the associated audience feedback.</li>
            </ol>

            <br />
            <h1>Known Bugs</h1>
            <li>Sometimes you need to change the text of a punchline and then undo that change for the app to reload the joke</li>
            <li>x-axis tick marks are missing when using the slider</li>
            <li>Clicking on a line no longer unassigns a punchline. You ahve to edit the raw text and then click the punchline again</li>
            <li>Changing text from the bottom does not update the raw text or preview pane. Always edit jokes from the top. The bottom is only for analysis now.</li>


            <br />
            <h1>Future Updates</h1>
            <ol>
              <li><strong>AI Integrations</strong>: v0.3 will incorporate AI assistance for writing and editing material.</li>
              <li>Ability to rate jokes relative to each other and/or others</li>
              <li>Ability to have app select the best material based on joke efficency to fill a given time slot.</li>
              <li><strong>Historical joke analysis</strong>: Track jokes across multiple performances</li>

            </ol>
            
            <button className="close-button" onClick={closeTutorial}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default TutorialComponent;
